import React, { useState, Children } from 'react';
import { motion } from 'framer-motion';
import { JourneyTimeline } from './JourneyTimeline';
import { Users, Database, PlayCircle, Monitor } from 'lucide-react';
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    x: -20
  },
  show: {
    opacity: 1,
    x: 0
  }
};
export function SlideInsideBooth() {
  const [imgError, setImgError] = useState(false);
  return <div className="h-full w-full bg-[#EDF4F8] text-[#1B4F72] p-8 md:p-12 flex flex-col" data-id="element-390">
      <JourneyTimeline currentStage={4} data-id="element-391" />

      <motion.div initial={{
      opacity: 0,
      y: 10
    }} animate={{
      opacity: 1,
      y: 0
    }} className="mb-6 border-l-4 border-[#4A7FA5] pl-6" data-id="element-392">
        <div className="flex items-center gap-3 mb-2" data-id="element-393">
          <span className="text-4xl" data-id="element-394">💬</span>
          <h2 className="text-3xl font-bold text-[#1B4F72]" data-id="element-395">
            Inside the Booth
          </h2>
        </div>
        <p className="text-xl text-[#4A7FA5] font-medium" data-id="element-396">
          Goal: Deepen the conversation, build relationships
        </p>
      </motion.div>

      <div className="flex-1 grid grid-cols-1 md:grid-cols-[1fr_1.2fr] gap-8 min-h-0" data-id="element-397">
        {/* Left Column: Tactics + Features stacked */}
        <div className="flex flex-col gap-5 overflow-auto" data-id="element-398">
          <motion.div className="bg-white p-5 rounded-xl shadow-sm border border-gray-100" variants={container} initial="hidden" animate="show" data-id="element-399">
            <h3 className="text-lg font-bold text-[#1B4F72] mb-4 flex items-center gap-2" data-id="element-400">
              <span className="w-8 h-1 bg-[#4A7FA5] rounded-full" data-id="element-401"></span>
              Tactics
            </h3>
            <ul className="space-y-3" data-id="element-402">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-403">
                <Users className="w-5 h-5 text-[#4A7FA5] mt-0.5 shrink-0" data-id="element-404" />
                <span className="text-gray-700 text-sm" data-id="element-405">
                  Sales rep–led Snak-based conversations using iPads
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-406">
                <Database className="w-5 h-5 text-[#4A7FA5] mt-0.5 shrink-0" data-id="element-407" />
                <span className="text-gray-700 text-sm" data-id="element-408">
                  Capture HCP preferences, data, and next steps via Input Cues
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-409">
                <PlayCircle className="w-5 h-5 text-[#4A7FA5] mt-0.5 shrink-0" data-id="element-410" />
                <span className="text-gray-700 text-sm" data-id="element-411">
                  Guided demo journeys or objection-handling Snaks™
                </span>
              </motion.li>
            </ul>
          </motion.div>

          <motion.div className="bg-[#4A7FA5]/5 p-5 rounded-xl border border-[#4A7FA5]/10" variants={container} initial="hidden" animate="show" data-id="element-412">
            <h3 className="text-lg font-bold text-[#1B4F72] mb-4 flex items-center gap-2" data-id="element-413">
              <span className="w-8 h-1 bg-[#7CB9D8] rounded-full" data-id="element-414"></span>
              Snakker™ Features
            </h3>
            <ul className="space-y-3" data-id="element-415">
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-416">
                <div className="w-2 h-2 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-417" />
                <span className="text-gray-700 text-sm" data-id="element-418">
                  <strong className="text-[#1B4F72]" data-id="element-419">Input Cue™</strong> for
                  name, interest, sign-ups
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-420">
                <div className="w-2 h-2 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-421" />
                <span className="text-gray-700 text-sm" data-id="element-422">
                  <strong className="text-[#1B4F72]" data-id="element-423">
                    Feedback + Breadcrumbs
                  </strong>{' '}
                  for interaction quality
                </span>
              </motion.li>
              <motion.li variants={item} className="flex items-start gap-3" data-id="element-424">
                <div className="w-2 h-2 rounded-full bg-[#7CB9D8] mt-1.5 shrink-0" data-id="element-425" />
                <span className="text-gray-700 text-sm" data-id="element-426">
                  Embedded CTAs: "Book a meeting," "Download slides," etc.
                </span>
              </motion.li>
            </ul>
          </motion.div>
        </div>

        {/* Right Column: Example Screenshot */}
        <motion.div className="flex flex-col items-center justify-center" initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} data-id="element-427">
          <a href="https://player.snakker.io/s/lyDA4_N6hU" target="_blank" rel="noopener noreferrer" className="relative w-full rounded-xl overflow-hidden shadow-lg border border-gray-200 bg-gray-100 block transition-shadow hover:shadow-xl hover:border-[#4A7FA5]/40" data-id="element-428">
            {imgError ? <div className="flex flex-col items-center justify-center w-full h-64 text-gray-400" data-id="element-429">
                <Monitor className="w-12 h-12 mb-3 text-[#4A7FA5]/40" data-id="element-430" />
                <p className="text-sm font-medium" data-id="element-431">Image could not be loaded</p>
              </div> : <img src="https://cdn.magicpatterns.com/uploads/mqGiMzwaC8ySRv1TPEQBU1/Screenshot_2026-02-11_at_18.10.17.png" alt="Snak™ interactive engagement — specialty selection screen" className="w-full h-auto object-contain" onError={() => setImgError(true)} data-id="element-432" />}
          </a>
          <motion.p className="mt-3 text-xs text-[#5B8FAF] italic text-center" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} data-id="element-433">
            Example Snak™ —{' '}
            <a href="https://player.snakker.io/s/lyDA4_N6hU" target="_blank" rel="noopener noreferrer" className="underline text-[#1B4F72]" data-id="element-434">
              click to explore
            </a>
          </motion.p>
        </motion.div>
      </div>
    </div>;
}